// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"544":"879bfa53","901":"0a6aa023"}[chunkId] + ".css";
};